import { CoreMonthlyPlanID } from 'common/util/isCore';
import { ProMonthlyPlanID } from 'common/util/isPro';

import type { UseCase } from 'common/subdomain/admin/AdminOnboarding/Types';

const getPlanIDFromUseCase = (useCase: UseCase) => {
  const { customAccess, indexed } = useCase;

  if (customAccess) {
    return ProMonthlyPlanID;
  }

  if (indexed) {
    return CoreMonthlyPlanID;
  }

  return;
};

export default getPlanIDFromUseCase;
